import _regeneratorRuntime from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from '~/api/api.js';
import isButton from '~/components/button.vue';
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators';
var miniToastr = void 0;
if (process.browser) {
  miniToastr = require('mini-toastr');
}
export default {
  middleware: ['auth'],
  validations: {
    email: {
      required: required,
      email: email
    },
    password: {
      minLength: minLength(6)
    },
    repeatPassword: {
      sameAsPassword: sameAs('password')
    }
  },
  mounted: function mounted() {
    miniToastr.init();
  },

  notifications: {
    showLoginError: {
      title: 'Error',
      message: 'Hello from nuxt.js',
      type: 'error'
    },
    showSuccess: {
      title: 'Success',
      message: '',
      type: 'success'
    }
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          error = _ref.error;
      var tokenData, result, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              tokenData = store.state.authUser;
              _context.next = 3;
              return API.setToken(tokenData.tokenID);

            case 3:
              _context.next = 5;
              return API.GetUser(tokenData.userID);

            case 5:
              result = _context.sent;
              data = result.data.datas;

              data.password = '';
              return _context.abrupt('return', {
                tokenData: tokenData,
                userData: data,
                email: '',
                submitStatus: ''
              });

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),

  methods: {
    CreateCustomer: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var btn, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$v.$touch();
                btn = this.$refs.btnCreate;

                if (!this.$v.$invalid) {
                  _context2.next = 8;
                  break;
                }

                this.submitStatus = 'Error! Please Check Input Field';
                btn.enabled();
                return _context2.abrupt('return');

              case 8:
                this.submitStatus = '';

              case 9:
                if (!(this.userData.email === '')) {
                  _context2.next = 13;
                  break;
                }

                this.showLoginError({
                  message: 'Please insert Email'
                });
                btn.enabled();
                return _context2.abrupt('return');

              case 13:
                if (!(this.userData.customerName === '')) {
                  _context2.next = 17;
                  break;
                }

                this.showLoginError({
                  message: 'Please insert CustomerName'
                });
                btn.enabled();
                return _context2.abrupt('return');

              case 17:
                if (!(this.userData.branch === '')) {
                  _context2.next = 21;
                  break;
                }

                this.showLoginError({
                  message: 'Please insert Branch'
                });
                btn.enabled();
                return _context2.abrupt('return');

              case 21:
                if (!(this.userData.phone === '')) {
                  _context2.next = 25;
                  break;
                }

                this.showLoginError({
                  message: 'Please insert Phone'
                });
                btn.enabled();
                return _context2.abrupt('return');

              case 25:
                if (!(this.userData.businessType === '')) {
                  _context2.next = 29;
                  break;
                }

                this.showLoginError({
                  message: 'Please insert Business Type'
                });
                btn.enabled();
                return _context2.abrupt('return');

              case 29:
                if (!(this.userData.contactName === '')) {
                  _context2.next = 33;
                  break;
                }

                this.showLoginError({
                  message: 'Please insert ContactName'
                });
                btn.enabled();
                return _context2.abrupt('return');

              case 33:
                _context2.next = 35;
                return API.setToken(this.tokenData.tokenID);

              case 35:
                _context2.next = 37;
                return API.UpdateMember(this.userData);

              case 37:
                result = _context2.sent;

                if (result.data.flag) {
                  this.showSuccess({
                    message: 'Complete'
                  });
                  window.location.href = '/account/profile';
                } else {
                  this.showLoginError({
                    message: result.message
                  });
                }
                btn.enabled();

              case 40:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function CreateCustomer() {
        return _ref3.apply(this, arguments);
      }

      return CreateCustomer;
    }()
  },
  components: {
    isButton: isButton
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/customer/edit.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/customer/edit.vue
// module chunks = 5